const GIFT_VARIANT_ID = 43986926960727;

class TatvamasiGiftWrap {

    constructor() {

        this.checkbox = document.getElementById("gift-wrap-checkbox");
        this.wrapper = document.getElementById("gift-message-wrapper");
        this.message = document.getElementById("gift-message");
        this.counter = document.getElementById("gift-count");

        this.init();

    }

    init() {

        if (!this.checkbox) return;

        this.checkbox.addEventListener("change", () => {

            this.wrapper.classList.toggle("show", this.checkbox.checked);

        });

        this.message.addEventListener("input", () => {

            this.counter.textContent = 250 - this.message.value.length;

        });

        this.listenForCartUpdates();

    }

    listenForCartUpdates() {

        if (typeof subscribe !== "function") return;

        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

            if (!this.checkbox.checked) return;

            this.addGiftWrap();

        });

    }

    async addGiftWrap() {

        try {

            await fetch("/cart/add.js", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },

                body: JSON.stringify({

                    id: GIFT_VARIANT_ID,
                    quantity: 1

                })

            });

        }

        catch (e) {

            console.error("Gift Wrap Error", e);

        }

    }

}

document.addEventListener("DOMContentLoaded", () => {

    new TatvamasiGiftWrap();

});